<script>
  import dialogMixin from "./mixins/dialog";

  export default {
    mixins: [dialogMixin],
    props: {
      brandsList: {
        type:Array,
        default: () => {
          return []
        }
      }
    },
    data() {
      return {}
    },
    computed: {
      isNotHasbrandsContact() {
        return this.brandsList.every((item) => {
          return !item.contact.length
        })
      }
    },
    methods: {
    },
  }
</script>
<template>
  <el-dialog
    :visible.sync="dialogMixinDialogVisible"
    :before-close="$DialogMixinOnClose"
    :custom-class="`${ $style.dialogContact } isStyleContact`"
    width="876px"
    append-to-body
  >
    <div class="sectionTitle text-center mb-5 font-medium color-gray-7">洽詢專線</div>
    <div class="text-base md:text-lg dialogContact__content mb-5 text-md-left text-center">
      <p style="line-height:2">
        如有任何問題，歡迎直接撥打電話洽詢，謝謝!
      </p>
      <div 
        v-for="(brandItem,$index) in brandsList" 
        :key="$index"
        class="color-gray-6 dialogContact__brandsList"
      >
        <template v-if="brandItem.contact.length">
          <div class="mb-2">{{ brandItem.title }}</div>
          <p 
            v-for="(contact, $index2 ) in brandItem.contact" 
            :key="$index2"
            class="my-1"
          >
            <i class="icomoon icon-call"></i>
            {{contact.name}}{{contact.gender}} 
            <a
              :href="`tel:${contact.countryCode}-${contact.phone}`"
              class="color-gray-6 text-decoration tel">
              {{contact.countryCode}}-{{contact.phone}} 
            </a>
            {{contact.extension ? `分機：${contact.extension}` : ''}}
          </p>
        </template>
      </div>
      <p v-if="isNotHasbrandsContact" class="color-gray-6 mt-3 text-center">
        <i class="icomoon icon-call"></i>
        <a
          href="tel:02-26560777"
          class="color-gray-6 text-decoration tel">
          02-26560777
        </a>
        或
        <a
          href="tel:02-26565656"
          class="color-gray-6 text-decoration tel">
          02-26565656
        </a>
      </p>
    </div>
    <!-- <BaseButton
      class="isStylePrimary isRadius isFull my-5"
      @click="dialogMixinDialogVisible = !dialogMixinDialogVisible"
    >
      我瞭解了
    </BaseButton> -->
  </el-dialog>
</template>
<style lang="scss" module>
  .dialogContact {
    padding-right: 30px;
    padding-left: 30px;

    :global {
      .dialogContact {
        &__content {
          max-width: 27.2rem;
          margin: 0 auto;
        }
        &__brandsList {
          &:not(:last-child) {
            margin-bottom: 20px;
          }
        }
      }
      .sectionTitle {
        font-size: 24px;
      }
      .tel {
        &:hover, &:active {
          color: $color-primary;
          text-decoration: none;
        }
      }
      
    }
  }
</style>
